<template>
    <div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="h3 mb-4">Добро пожаловать, {{ userFullName }}</div>

                <div v-if="cannotWork"
                     class="text-secondary d-flex flex-column flex-sm-row align-items-center ml-2">
                    <b-icon icon="exclamation-triangle-fill" scale="1.5" class="mr-4 mb-3"/>
                    <span>
                        <span v-if="noOrganization"  class="d-flex flex-column">
                            <span>Для&nbsp;полноценного доступа к&nbsp;системе необходимо указать&nbsp;организацию.</span>
                            <span>Обратитесь к&nbsp;администратору.</span>
                        </span>
                        <span v-else-if="noMunicipality"  class="d-flex flex-column">
                            <span>Для&nbsp;полноценного доступа к&nbsp;системе необходимо указать организацию и&nbsp;муниципалитеты.</span>
                            <span>Обратитесь к&nbsp;администратору.</span>
                        </span>
                        <span v-else-if="noContract"  class="d-flex flex-column">
                            <span>Не&nbsp;найдено ни&nbsp;одного действительного контракта.  </span>
                            <span>Работа в&nbsp;системе невозможна.</span>
                        </span>
                    </span>
                </div>

                <div v-if="!isSuperuser && isVetStationWithoutContract"
                     class="text-secondary d-flex flex-column flex-sm-row align-items-center ml-2">
                    <b-icon icon="info-circle" scale="1.5" class="mr-4 mb-3"/>
                    <span class="d-flex flex-column">
                        <span>Работа в системе ограничена из-за отсутствия действительного контракта.</span>
                        <span>Можно просматривать разделы и объекты без возможности редактирования и удаления.</span>
                    </span>
                </div>

            </div>
        </div>

        <div class="row" v-if="!cannotWork">
            <div v-if="canWorkWithRequests"  class="col-12 p-3">
                <b-card class="shadow p-3">
                    <div class="d-flex">
                        <div class="d-flex flex-grow-1 align-items-center">
                            <div class="d-flex flex-column">
                                <span class="h4 ">Текущие заявки</span>
                                <span class="text-secondary">Показано {{ requests.length }} из {{ requestsTotal }}</span>
                            </div>
                        </div>
                        <b-link :to="{ name: 'requestsList' }" class="d-flex align-items-center mr-3">
                            <span class="mr-2">К заявкам</span>
                            <b-icon icon="arrow-right" />
                        </b-link>
                    </div>
                    <div class="clearfix mb-4"></div>
                    <div v-if="requests.length > 0" class="d-flex flex-wrap w-100">
                        <div v-for="(request, i) in requests" class="position-relative col-xs-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 mb-3 flex-grow-1">
                            <div class="request-card shadow d-flex flex-column mr-3 flex-grow-1 h-100" :class="getCardStatusClass(request)">
                                <div class="d-flex align-items-start flex-grow-1 mb-3">
                                    <div class="d-flex flex-column flex-grow-1">
                                        <b-link :to="{ name: 'requestsDetail', params: { id: request.id } }">
                                            <span class="h5">{{ request.activityName }} №{{ request.id }}</span>
                                        </b-link>
                                        <request-status-indicator :request="request" class="flex-grow-1 "/>
                                    </div>
                                    <span class="d-flex flex-column text-secondary align-items-end flex-grow-0">
                                        <span>{{ request.createdAtDate }} </span>
                                        <small>{{ request.createdAtTime }}</small>
                                    </span>
                                </div>
                                <span class=" mr-2 mb-2 mt-2 flex-grow-0"> {{ request.addressHumanReadable }} </span>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <span class="text-secondary">Заявок не найдено</span>
                    </div>
                </b-card>
            </div>

            <div v-if="canWorkWithAnimals"  class="col-12 p-3">
                 <animals-list />
            </div>

        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import httpClient from "@/http";
    import {Request} from "@/pages/AppPages/Requests/request";
    import { RequestStatus } from "@/pages/AppPages/Requests/request";
    import {ACTIVITIES} from "@/store/auth/auth";
    import RequestStatusIndicator from "@/pages/AppPages/Requests/RequestStatusIndicator.vue";
    import AnimalsList from "@/pages/AppPages/Animals/AnimalsList.vue";

    export default {
        components: {
            AnimalsList,
            RequestStatusIndicator
        },
        data() {
            return {
                requests: [],
                requestsTotal: 0
            }
        },
        computed: {
            ...mapGetters(['isInController', 'isInContractor', 'isInCustomer',
                'hasMunicipalityRestrictions',  'userOrganizationId', 'userFullName',
                'isSuperuser', 'userOrganizationMunicipalities',
                'userLastValidContract', 'canBeContracted', 'userOrganizationActivities']),
            hasValidContract() {
                return !this.canBeContracted || this.canBeContracted && this.userLastValidContract
            },
            noOrganization() {
                return !this.userOrganizationId;
            },
            noMunicipality() {
                return this.hasMunicipalityRestrictions && this.userOrganizationMunicipalities.length === 0
            },
            noContract() {
                return !this.isInController && this.isInContractor && !this.hasValidContract
            },
            cannotWork() {
                return !this.isSuperuser && (this.noContract || this.noMunicipality || this.noOrganization)
            },
            isVetStationWithoutContract() {
                 return this.isInController && this.isInContractor && !this.hasValidContract
            },
            canWorkWithRequests() {
                return this.isInContractor || this.isInCustomer
            },
            canWorkWithAnimals() {
                return this.isInController && !this.isInCustomer || this.isSuperuser
            },
            canWorkWithRaids() {
                return this.isInContractor &&
                    (this.userOrganizationActivities.includes(ACTIVITIES.CATCHING) || this.userOrganizationActivities.includes(ACTIVITIES.RELEASE))
            }
        },
        methods: {
            getCardStatusClass(request) {
                switch (request.status) {
                    case RequestStatus.OPEN: return 'bg-warning';
                    case RequestStatus.ASSIGNED: return 'bg-info';
                    case RequestStatus.WIP: return 'bg-primary';
                    case RequestStatus.DONE: return 'bg-success';
                    case RequestStatus.CANCELLED: return 'bg-danger';
                    default: return 'bg-white'
                }
            },
            fetchDashboard() {
                const vm = this;
                const dashboardUrl = '/accounts/users/dashboard/';
                httpClient.get(dashboardUrl).then((response) => {
                    vm.requestsTotal = response.data['requests_total'];
                    const requestsData = response.data['requests'];
                    if (requestsData && Array.isArray(requestsData)) {
                        for (const requestData of requestsData) {
                            let request = new Request();
                            request.applyData(requestData);
                            vm.requests.push(request);
                        }
                    }
                })
            },
        },
        mounted() {
            this.fetchDashboard();

        }
  };
</script>
<style scoped lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap.scss';
@import 'node_modules/bootstrap-vue/src/index.scss';
    .request-card {
        border-radius: 4px;
        padding: 15px 20px;
        //border: 1px solid $gray-200;

        &.bg-warning {
            background-color: lighten($warning, 45%) !important;
        }
        &.bg-primary {
            background-color: lighten($primary, 45%) !important;
        }
        &.bg-success {
            background-color: lighten($success, 50%) !important;
        }
        &.bg-danger {
            background-color: lighten($danger, 45%) !important;
        }
        &.bg-info {
            background-color: lighten($info, 50%) !important;
        }
    }

    .tag {
        background-color: white;
        border-radius: 12px;
        padding: 5px 12px;
        margin-right: 7px;
        margin-top: 5px
    }
</style>
